import { FREIGHT_TABLE_STATUS_FILTER } from "../constants/freightTableStatus";
import { FREIGHT_VALIDITY_STATUS_FILTER } from "../constants/freightValidityStatus";

const TABLE_STATUS_QUERY = "table_status";
const VALIDITY_STATUS_QUERY = "effective_period_status";

function pickEnumValue(value, allowed) {
  const normalized = String(value || "").toUpperCase();
  return Object.keys(allowed)
    .map((key) => allowed[key])
    .indexOf(normalized) !== -1
    ? normalized
    : null;
}

// Valor fora do enum é descartado aqui: a /listagem responde 422 para ele.
export function readStatusFiltersFromQuery(query) {
  const source = query || {};
  const result = {};

  const tableStatus = pickEnumValue(
    source[TABLE_STATUS_QUERY],
    FREIGHT_TABLE_STATUS_FILTER,
  );
  if (tableStatus) result.tableStatus = tableStatus;

  const effectivePeriodStatus = pickEnumValue(
    source[VALIDITY_STATUS_QUERY],
    FREIGHT_VALIDITY_STATUS_FILTER,
  );
  if (effectivePeriodStatus) {
    result.effectivePeriodStatus = effectivePeriodStatus;
  }

  return result;
}

export function buildStatusFiltersQuery(query, filters) {
  const next = { ...(query || {}) };
  delete next[TABLE_STATUS_QUERY];
  delete next[VALIDITY_STATUS_QUERY];

  if (
    filters.tableStatus &&
    filters.tableStatus !== FREIGHT_TABLE_STATUS_FILTER.ALL
  ) {
    next[TABLE_STATUS_QUERY] = filters.tableStatus;
  }

  if (
    filters.effectivePeriodStatus &&
    filters.effectivePeriodStatus !== FREIGHT_VALIDITY_STATUS_FILTER.ALL
  ) {
    next[VALIDITY_STATUS_QUERY] = filters.effectivePeriodStatus;
  }

  return next;
}

export function isSameStatusQuery(a, b) {
  const left = a || {};
  const right = b || {};
  return (
    left[TABLE_STATUS_QUERY] === right[TABLE_STATUS_QUERY] &&
    left[VALIDITY_STATUS_QUERY] === right[VALIDITY_STATUS_QUERY]
  );
}
